import React, { useEffect, useState } from 'react';
import './history.css';

function authHeader() { const t = localStorage.getItem('token'); return t ? { Authorization: `Bearer ${t}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }; }

export default function History() {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [classes, setClasses] = useState([]);
  const [studentHistory, setStudentHistory] = useState([]);
  const [teacherHistory, setTeacherHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingClasses, setLoadingClasses] = useState(false);

  useEffect(() => { fetchYears(); }, []);

  const fetchYears = async () => {
    try {
      const res = await fetch(`${apiUrl}/api/admin/school-years`, { headers: authHeader() });
      if (res.ok) {
        const jd = await res.json();
        // endpoint returns { schoolYears: [...] } or similar; guard for both
        const list = jd.schoolYears || jd.years || jd || [];
        setYears(list || []);
        if (!selectedYear) {
          // pick default year if present
          const def = (list || []).find(y => y && (y.default === 1 || y.is_default || y.isDefault)) || (list && list[0]);
          if (def && def.id) setSelectedYear(String(def.id));
        }
      }
    } catch (e) { console.error(e); }
  };

  const fetchClasses = async (yearId) => {
    setLoadingClasses(true);
    try {
      const y = yearId || selectedYear || null;
      const q = y ? `?year_id=${encodeURIComponent(y)}` : '';
      const res = await fetch(`${apiUrl}/api/admin/classes/by-year${q}`, { headers: authHeader() });
      if (res.ok) {
        const jd = await res.json();
        setClasses(jd.classes || []);
      } else {
        setClasses([]);
      }
    } catch (e) { console.error(e); setClasses([]); }
    setLoadingClasses(false);
  };

  const fetchAllStudentHistory = async (yearId) => {
    setLoading(true);
    try {
      const y = yearId || selectedYear || null;
      const q = y ? `?year_id=${encodeURIComponent(y)}` : '';
      const res = await fetch(`${apiUrl}/api/admin/students/history${q}`, { headers: authHeader() });
      if (res.ok) {
        const jd = await res.json();
        setStudentHistory(jd.history || []);
      } else setStudentHistory([]);
    } catch (e) { console.error(e); setStudentHistory([]); }
    setLoading(false);
  };

  const fetchAllTeacherHistory = async (yearId) => {
    setLoading(true);
    try {
      const y = yearId || selectedYear || null;
      const q = y ? `?year_id=${encodeURIComponent(y)}` : '';
      const res = await fetch(`${apiUrl}/api/admin/teachers/history${q}`, { headers: authHeader() });
      if (res.ok) {
        const jd = await res.json();
        setTeacherHistory(jd.history || []);
      } else setTeacherHistory([]);
    } catch (e) { console.error(e); setTeacherHistory([]); }
    setLoading(false);
  };

  return (
    <div className="admin-page history-page">
      <div className="panel-header">
        <h2>History (per school year)</h2>
        <div className="panel-actions">
          <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>
            <option value="">-- Select year (or default) --</option>
            {years.map(y => (
              <option key={y.id} value={y.id}>{y.year_name || y.name || `${y.start || ''}-${y.end || ''}`}</option>
            ))}
          </select>
          <button onClick={() => fetchClasses(selectedYear)}>Load classes</button>
          <button onClick={() => fetchAllStudentHistory(selectedYear)}>Load all student history</button>
          <button onClick={() => fetchAllTeacherHistory(selectedYear)}>Load all teacher history</button>
        </div>
      </div>

      <div className="card">
        <h3>Classes for selected year</h3>
        {loadingClasses ? <div className="muted">Loading classes...</div> : (
          <table className="data-table small">
            <thead><tr><th>ID</th><th>Name</th><th>Grade</th><th>Teacher ID</th><th>School ID</th></tr></thead>
            <tbody>
              {(classes || []).map(c => (
                <tr key={c.id}><td>{c.id}</td><td>{c.name}</td><td>{c.grade_id || c.grade_name || '—'}</td><td>{c.teacher_id || '—'}</td><td>{c.school_id || '—'}</td></tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="card">
        <h3>Student history{selectedYear ? ` — year ${selectedYear}` : ''}</h3>
        {loading ? <div className="muted">Loading...</div> : (
          <table className="data-table small">
            <thead><tr><th>ID</th><th>Student</th><th>From class</th><th>To class</th><th>Changed at</th><th>Changed by</th></tr></thead>
            <tbody>
              {(studentHistory || []).map(r => (
                <tr key={r.id}><td>{r.student_id}</td><td>{r.student_name || r.student_full_name || '—'}</td><td>{r.from_class_name || r.from_class_id || '—'}</td><td>{r.to_class_name || r.to_class_id || '—'}</td><td>{r.changed_at || r.changed_at}</td><td>{r.changed_by_username || '—'}</td></tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="card">
        <h3>Teacher assignment history{selectedYear ? ` — year ${selectedYear}` : ''}</h3>
        {loading ? <div className="muted">Loading...</div> : (
          <table className="data-table small">
            <thead><tr><th>ID</th><th>Teacher</th><th>From class</th><th>To class</th><th>Assigned at</th><th>Changed by</th></tr></thead>
            <tbody>
              {(teacherHistory || []).map(r => (
                <tr key={r.id}><td>{r.teacher_id}</td><td>{r.teacher_username || '—'}</td><td>{r.from_class_name || r.from_class_id || '—'}</td><td>{r.to_class_name || r.to_class_id || '—'}</td><td>{r.assigned_at || r.assigned_at}</td><td>{r.changed_by_username || '—'}</td></tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
